<template>
  <div class="container">
    <header class="header-nav mb-5">
      <div class="row d-flex justify-content-between align-items-center"> 
        <div style="color:black">
           
            <p class="ml-2 pointer"  @click="$router.push('/')" > <base-icon icon_name="arrow-left"/>
            <!-- {{ $t('Provinces') }} -->
            </p>
        </div>
        <div class="">
          <img src="@/assets/logo.png" class="logo" />
        </div>
        <div class="pointer">
              <span @click="showMenu()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="27" viewBox="0 0 32 27">
                    <g id="menu_icon" data-name="menu icon" transform="translate(32 27) rotate(180)">
                      <path id="menu_icon-2" data-name="menu icon" d="M1,27a1,1,0,0,1-1-1V24.142a1,1,0,0,1,1-1H31a1,1,0,0,1,1,1V26a1,1,0,0,1-1,1ZM1,15.429a1,1,0,0,1-1-1V12.571a1,1,0,0,1,1-1H19a1,1,0,0,1,1,1v1.858a1,1,0,0,1-1,1ZM1,3.857a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H31a1,1,0,0,1,1,1V2.858a1,1,0,0,1-1,1Z" fill="#700e57"/>
                    </g>
                  </svg> 
              </span> 
        </div>
        <!-- <div class="d-flex justify-content-end align-items-center"> -->

            
          <!-- <div class="btn-group" role="group" aria-label="Third group">
            <button
              type="button"
              class="btn float-right btn-black-rounded"
              @click="showMenu()"
            >
              <base-icon icon_name="sidebar" />
            </button>
          </div> -->
        <!-- </div> -->
      </div>
    </header>

    <!-- <div class="text-center mt-4">
      <div
        class="icon-location"
        :class="{ 'icon-location-active': type_selected === 'restaurant' }"
        @click="selectMainLocation('restaurant')"
      >
        <div class="icon-location-image">
          <img src="@/assets/media/icons/stockholm/Cooking/Dinner.svg"/>
        </div>
        <div class="text">
          {{ $t("restaurant") }}
        </div>
      </div>
      <div
        class="icon-location"
        :class="{ 'icon-location-active': type_selected === 'hotel' }"
        @click="selectMainLocation('hotel')"
      >
        <div class="icon-location-image">
         <img src="@/assets/media/icons/stockholm/Home/Bed.svg"/>
        </div>
        <div class="text">
          {{ $t("hotel") }}
        </div>
      </div>
      
    </div> -->
  
    <!--  -->
    <!-- <h5>{{ $t('Welcome')}} </h5>
    <h4 class="mb-4"> {{selectProvince.name}}</h4> -->

    <div class="input-group input-group-lg shadow-sm">
      <input
        v-model="filter.search"
        type="text"
        class="form-control input-search"
        aria-label="Sizing example input"
        :placeholder="$t('finding_here')"
        aria-describedby="inputGroup-sizing-lg"
        autocomplete="off"
        @keyup.enter="getList(false)"
        @keyup="searchPlace()"
      />
      <div class="input-group-prepend">
        <span class="input-group-text icon-input" @click="getList(false)">
          <base-icon icon_name="search" />
        </span>
      </div>
      <div
        v-if="search_hotel.length > 0 && drop_search"
        v-click-outside="closeDropDown"
        class="drop-search-item shadow-sm"
      >
        <div v-for="sl in search_hotel" :key="sl.id" class="item">
          <p @click="openSearch(sl)">
            <img v-if="sl.type === 'hotel'" src="@/assets/media/icons/stockholm/Home/Bed.svg" alt />
            <img v-else src="@/assets/media/icons/stockholm/Cooking/Dinner.svg" alt />  
            {{ sl.title}}
          </p>
        </div>
      </div>
    </div>

    <div class="mt-4 mb-4">
        <button class="btn btn-outline btn-type-location" 
          @click="selectMainLocation('restaurant')"
         :class="{ 'icon-location-active': type_selected === 'restaurant' }">
          {{ $t("restaurant") }}
        </button>
          <button class="btn  btn-outline btn-type-location ml-2"
             @click="selectMainLocation('hotel')"
            :class="{ 'icon-location-active': type_selected === 'hotel' }">
           {{ $t("hotel") }}
        </button>
    </div>

      <template v-if="mealAndCuisines.meals">
        <menu-scroll :data="mealAndCuisines" @input="menuSelected"></menu-scroll> 
      </template>


    <!--  -->
    <!-- <div v-if="recentPlace.id > 0">
      <div class="mt-20">
        <h3 class="text-top-card">
          {{ $t("recent") }}
        </h3>
        
        <location-card
          :key="recentPlace.id"
          style="max-width: 500px"
          :title="recentPlace.title"
          :isOpen="recentPlace.is_open"
          :image="recentPlace.image"
          :type="recentPlace.placeSelected"
          :address="recentPlace.address"
          :open_times="recentPlace.open_times"
          @click.native="openLocation(recentPlace, 'restaurant')"
        />
      </div>
    </div> -->



    <div class="mt-20">
      <h3 class="text-top-card">
        {{ $t("listing") }} : {{ $t(type_selected) }}
      </h3>
    </div>

    <div
      v-if="(main_location.length <= 0) & !loading"
      class="mt-20 text-center mt-5"
    >
        <div>
          <img src="@/assets/icon/icon01.svg" width="100" alt="">
        </div>
      <p class="mt-2"> 
        {{ $t("Restaurant is not found!") }}
      </p>
    </div>
    <div class="row"> 
      <div
        v-for="(hotel, index) in main_location"
        :key="index"
        class="col-lg-6 col-md-6 col-sm-12 col-xs-12"
      >
       
        <location-card
          :title="hotel.title"
          :image="hotel.image"
          :type="type_selected"
          :location_id="hotel.location_id"
          :description="hotel.location_name"
          :isOpen="hotel.is_open"
          :address="hotel.address" 
          :open_times="hotel.open_times"
          :delivery_by="hotel.delivery_by"
          @click.native="openLocation(hotel)"
        />
      </div>
    </div> 
  <div class="row" v-if="loading"> <loading-location /></div>
    <!--  -->
  <div class="row" v-if="loadmore && !loading">
    <button
      style="max-width: 130px;"
      type="button"
      class="btn btn-outline-secondary center"
      @click="load_more()"
    >
      {{ $t("more") }}
    </button> 
    </div>
    <div
      v-if="modalChange"
      class="modal shadow-lg fade show"
      tabindex="-1"
      role="dialog"
      style="padding-right: 17px; display: block"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <base-icon icon_name="info" />
              Change Information
            </h5>
          </div>
          <div class="modal-body">
            <h5>you're recently location is : {{ placeSelected.title }}</h5>
            <p>
              you had item selected in the basket, if you change the location so
              the basket will be clear!
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-round"
              data-dismiss="modal"
              @click="keepPlace()"
            >
              Keep
            </button>
            <button type="button" class="btn btn-brand" @click="changePlace()">
              Change
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isHotel"
      class="modal shadow-lg fade show"
      tabindex="-1"
      role="dialog"
      style="padding-right: 17px; display: block"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Choose Restaurant</h5>
            <button
              type="button"
              class="btn btn-round"
              data-dismiss="modal"
              @click="isHotel = false"
            >
              Close
            </button>
          </div>
          <div class="modal-body">
            <div v-if="!restaurant_in_hotels.length" class="text-center">
              <img
                src="@/assets/none.png"
                class="img-fluid p-2"
                alt
                style="max-width: 200px"
              />
              <br />
              <p>No Restaurant Available!</p>
            </div>

            <template v-for="restaurant_in_hotel in restaurant_in_hotels">
              <location-card
                :key="`${restaurant_in_hotel.id}_1`"
                :title="restaurant_in_hotel.title"
                :image="restaurant_in_hotel.image"
                :type="'restaurant'"
                :isOpen="restaurant_in_hotel.is_open"
                :location_id="restaurant_in_hotel.location_id"
                :description="restaurant_in_hotel.location_name"
                :address="restaurant_in_hotel.address"
                :open_times="restaurant_in_hotel.open_times"
                :delivery_by="restaurant_in_hotel.delivery_by"
                @click.native="openLocation(restaurant_in_hotel)"
              />
            </template>
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="css">
  .btn-outline{
    border: 1px solid lightgray;
    border-radius: 100px;
  }
</style>
<script> 
import store from "@/store"; 

export default {
  name: "HomePage",
  layout: "default",
  middleware: ['locations'],
  metaInfo: {
    title: "DiscoverLao Ordering",
  },
  data: () => ({
    slug: null,
    type_selected: "restaurant", 
    next_page: 1,
    main_location: [],
    loadmore: true,
    drop_search: false,
    modalChange: false,
    placeBeforeSubmit: {},
    isHotel: false,
    restaurant_in_hotels: [],
    filter: {
      search: '',
      meal_types: '',
      cuisines: ''
    }
  }),
  computed: {
    selectProvince() {
      return store.getters["province/selectProvince"];
    },
    recentPlace() {
      return store.getters["location_selected/recentSeletedPlace"];
    },
    order() {
      return store.getters["order/order"] || [];
    },
    placeSelected() {
      return store.getters["location_selected/placeSelected"] || {};
    },
    hotels() {
      return store.getters["main_location/hotel"] || [];
    }, 
    mealAndCuisines() {
      return store.getters["main_location/filters"];
    },
    drop_search_list() {
      return store.getters["main_location/search_hotel"] || [];
    },
    meta() {
      return store.getters["main_location/meta"];
    },
    loading() {
      return store.getters["main_location/loading"];
    },
    search_hotel() {
      return store.getters["main_location/search_hotel"];
    },
    search_loading() {
      return store.getters["main_location/search_loading"];
    },
  },
  mounted() {
    this.slug = this.$route.params.slug
    this.getList(false);
    this.searchPlace();
  },
  methods: {
    async showMenu() {
      await store.dispatch("nav/nav_menu");
    },
    selectMainLocation(val) {
      this.type_selected = val;
      this.getList(false);
    },
    async openSearch(place) {
      this.placeBeforeSubmit = place;
      if (this.order.length > 0 && this.placeSelected.id !== place.id) {
        this.modalChange = true;
        return;
      }
      this.type_selected = place.type;

      if(place.type == 'hotel')
        this.$router.push({ name: "hotel_detail",  params: { slug: place.slug }}); 
      else  
        this.$router.push({ name: "detail", params: { id: place.slug } });
        
    },
    async getList(next) {
      let data = { 
        limit: 100,
        next_page: this.next_page,
        type: this.type_selected, 
        province_slug: this.slug,
        ...this.filter 
      };


      if (next == false) {
        this.loadmore = true;
        data.next_page = 1;
        this.main_location = [];
       
      }
      await store.dispatch("main_location/getHotels", data); 

      if (this.hotels.length > 0) {
        this.hotels.forEach((el) => {
          this.main_location.push(el);
        });
      } else {
        this.loadmore = false;
      }
      if (this.next_page >= this.meta.last_page) {
        this.loadmore = false;
      } else {
        this.loadmore = true;
      }



    },
    async searchPlace() {
      this.drop_search = true;
      if (this.filter.search.length < 4) {
        await store.dispatch("main_location/clearSearch");
        return;
      }
      await store.dispatch("main_location/searchSuggestion", this.filter);
    },
    async keepPlace() {
      await this.$router.push({
        name: "detail",
        params: { id: this.placeSelected.slug },
      });
    },
    async changePlace() {
      await store.dispatch("order/clearOrder");
      await this.openLocation(this.placeBeforeSubmit);
    }, 

    openLocation(hotel, recentType) {  
      if(recentType) this.type_selected  = "restaurant"  
      if (this.type_selected === "restaurant") {  
        this.$router.push({ name: "detail", params: { id: hotel.slug } });
      } else {  
        this.$store.dispatch("location_selected/setHotel", hotel);
        this.$router.push({ name: "hotel_detail",  params: { slug: hotel.slug }}); 
      } 
    },
    load_more() {
      var vm = this;
      vm.next_page = vm.meta.current_page + 1;
      if (vm.next_page > vm.meta.last_page) {
        vm.loadmore = false;
        return;
      }
      vm.getList(true);
    },
    closeDropDown() {
      this.drop_search = false;
    },
    goHome() {
      this.$router.push({ name: "province" }).catch((err) => {});
    },

    async filterSubmit(){ 
        await  this.getList(false)
    },

    menuSelected(event){ 
        if(event.cuisines.id){
            this.filter.cuisines = event.cuisines.id
        }else {
           this.filter.cuisines = ''
        }
        if(event.meal.id){
          this.filter.meal_types = event.meal.id
        } else{
          this.filter.meal_types=  ''
        }
        this.filterSubmit();
    },
  },
};
</script>